<div id="master-wrapper" class="master-wrapper">
  <div id="master-container" class="master-container">
    <router-outlet></router-outlet>
  </div>

  <div id="master-footer" class="visible">

  </div>
</div>